<template>
    <header>
        <!--  BEGIN NAVBAR  -->
        <div class="header-container fixed-top">
            <div class="header navbar navbar-expand-sm">
                <ul class="navbar-item theme-brand flex-row text-center">
<!--                    <portal-target name="back-button" class="back-button">-->
<!--                        <div class="dropdown b-dropdown nav-item hamburger btn-group">-->
<!--                            <a href="javascript:void(0);" class="sidebarCollapse" data-placement="bottom" @click="$store.commit('toggleSideBar', !$store.state.is_show_sidebar)">-->
<!--                                <svg-->
<!--                                    xmlns="http://www.w3.org/2000/svg"-->
<!--                                    width="24"-->
<!--                                    height="24"-->
<!--                                    viewBox="0 0 24 24"-->
<!--                                    fill="none"-->
<!--                                    stroke="currentColor"-->
<!--                                    stroke-width="2"-->
<!--                                    stroke-linecap="round"-->
<!--                                    stroke-linejoin="round"-->
<!--                                    class="feather feather-menu"-->
<!--                                >-->
<!--                                    <line x1="3" y1="12" x2="21" y2="12"></line>-->
<!--                                    <line x1="3" y1="6" x2="21" y2="6"></line>-->
<!--                                    <line x1="3" y1="18" x2="21" y2="18"></line>-->
<!--                                </svg>-->
<!--                            </a>-->
<!--                        </div>-->
<!--                    </portal-target>-->
                    <li class="nav-item theme-logo">
                        <a href="/objednavky">
                            <img src="@/assets/img/navbar/logo.png" class="navbar-logo" alt="logo" />
                        </a>
                    </li>
                </ul>
                <div class="d-none horizontal-menu">
                    <a href="javascript:void(0);" class="sidebarCollapse" data-placement="bottom" @click="$store.commit('toggleSideBar', !$store.state.is_show_sidebar)">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="feather feather-menu"
                        >
                            <line x1="3" y1="12" x2="21" y2="12"></line>
                            <line x1="3" y1="6" x2="21" y2="6"></line>
                            <line x1="3" y1="18" x2="21" y2="18"></line>
                        </svg>
                    </a>
                </div>
<!--                <ul class="navbar-item flex-row ml-md-0 ml-auto">-->
<!--                    <li class="nav-item align-self-center search-animated" :class="{ 'show-search': $store.state.is_show_search }">-->
<!--                        <svg-->
<!--                            @click="$store.commit('toggleSearch', !$store.state.is_show_search)"-->
<!--                            xmlns="http://www.w3.org/2000/svg"-->
<!--                            width="24"-->
<!--                            height="24"-->
<!--                            viewBox="0 0 24 24"-->
<!--                            fill="none"-->
<!--                            stroke="currentColor"-->
<!--                            stroke-width="2"-->
<!--                            stroke-linecap="round"-->
<!--                            stroke-linejoin="round"-->
<!--                            class="feather feather-search toggle-search"-->
<!--                        >-->
<!--                            <circle cx="11" cy="11" r="8"></circle>-->
<!--                            <line x1="21" y1="21" x2="16.65" y2="16.65"></line>-->
<!--                        </svg>-->
<!--                        <form class="form-inline search-full form-inline search" :class="{ 'input-focused': $store.state.is_show_search }">-->
<!--                            <div class="search-bar">-->
<!--                                <input type="text" class="form-control search-form-control ml-lg-auto" placeholder="Search..." />-->
<!--                            </div>-->
<!--                        </form>-->
<!--                    </li>-->
<!--                </ul>-->

                <div class="navbar-item flex-row ml-auto align-items-center">
                    <div class="dark-mode d-flex align-items-center">
                        <a v-if="$store.state.dark_mode == 'light'" href="javascript:;" class="d-flex align-items-center" @click="toggleMode('dark')">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-sun"
                            >
                                <circle cx="12" cy="12" r="5"></circle>
                                <line x1="12" y1="1" x2="12" y2="3"></line>
                                <line x1="12" y1="21" x2="12" y2="23"></line>
                                <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line>
                                <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line>
                                <line x1="1" y1="12" x2="3" y2="12"></line>
                                <line x1="21" y1="12" x2="23" y2="12"></line>
                                <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line>
                                <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>
                            </svg>
                            <span class="ml-2">{{ $t('light') }}</span>
                        </a>
                        <a v-if="$store.state.dark_mode == 'dark'" href="javascript:;" class="d-flex align-items-center" @click="toggleMode('system')">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-moon"
                            >
                                <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
                            </svg>
                            <span class="ml-2">{{ $t('dark') }}</span>
                        </a>
                        <a v-if="$store.state.dark_mode == 'system'" href="javascript:;" class="d-flex align-items-center" @click="toggleMode('light')">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-airplay"
                            >
                                <path d="M5 17H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1"></path>
                                <polygon points="12 15 17 21 7 21 12 15"></polygon>
                            </svg>
                            <span class="ml-2">{{ $t('system') }}</span>
                        </a>
                    </div>

                    <b-dropdown toggle-tag="a" variant="icon-only" toggle-class="nav-link" class="nav-item language-dropdown" :right="true">
                        <template #button-content>
                           <svg v-if="selectedLang && selectedLang.code === 'sk'" xmlns="http://www.w3.org/2000/svg" width="32" height="32" class="flag-width" viewBox="0 0 32 32"><path fill="#204c9e" d="M1 11H31V21H1z"></path><path d="M5,4H27c2.208,0,4,1.792,4,4v4H1v-4c0-2.208,1.792-4,4-4Z" fill="#fff"></path><path d="M5,20H27c2.208,0,4,1.792,4,4v4H1v-4c0-2.208,1.792-4,4-4Z" transform="rotate(180 16 24)" fill="#db362f"></path><path d="M27,4H5c-2.209,0-4,1.791-4,4V24c0,2.209,1.791,4,4,4H27c2.209,0,4-1.791,4-4V8c0-2.209-1.791-4-4-4Zm3,20c0,1.654-1.346,3-3,3H5c-1.654,0-3-1.346-3-3V8c0-1.654,1.346-3,3-3H27c1.654,0,3,1.346,3,3V24Z" opacity=".15"></path><path d="M27,5H5c-1.657,0-3,1.343-3,3v1c0-1.657,1.343-3,3-3H27c1.657,0,3,1.343,3,3v-1c0-1.657-1.343-3-3-3Z" fill="#fff" opacity=".2"></path><path d="M15.65,10.232s.178,1.784,.178,5.353c-.025,3.645-2.751,5.49-4.752,6.46-2.001-.97-4.726-2.815-4.752-6.46,0-3.569,.178-5.353,.178-5.353H15.65Z" fill="#db362f"></path><path d="M10.673,19.945v-4.462c-1.511,0-1.94,.134-2.392,.27,.042-.456,.042-.915,0-1.371,.452,.137,.881,.27,2.392,.27v-1.24c-.477,0-1.135,.019-1.892,.277,.043-.457,.043-.917,0-1.374,.757,.254,1.415,.274,1.892,.274,0-.359-.111-1.132-.251-1.772,.436,.039,.874,.039,1.31,0-.14,.639-.251,1.412-.251,1.772,.477,0,1.135-.019,1.892-.274-.043,.457-.043,.917,0,1.374-.757-.258-1.415-.277-1.892-.277v1.24c1.511,0,1.94-.134,2.392-.27-.042,.456-.042,.915,0,1.371-.452-.137-.881-.27-2.392-.27v4.462h-.808Z" fill="#fff"></path><path d="M15.65,10.232s.178,1.784,.178,5.353c-.025,3.645-2.751,5.49-4.752,6.46-2.001-.97-4.726-2.815-4.752-6.46,0-3.569,.178-5.353,.178-5.353H15.65Z" fill="none"></path><path d="M11.076,22.044c1.241-.602,2.761-1.542,3.742-3.038-.007-.014-.011-.031-.017-.045-.56-1.184-1.576-1.367-2.268-.409-.089-.209-.191-.399-.304-.565-.805-1.181-1.973-.929-2.609,.565-.287-.397-.645-.614-1.014-.614-.518,0-.973,.424-1.268,1.072,.982,1.494,2.499,2.432,3.739,3.034Z" fill="#204c9e"></path><path d="M11.076,22.235l-.075-.036c-1.348-.654-2.385-1.395-3.169-2.266-1.103-1.225-1.668-2.687-1.679-4.347,0-3.537,.177-5.353,.179-5.371l.015-.155H15.806l.015,.155c.002,.018,.179,1.834,.179,5.37-.012,1.661-.577,3.123-1.679,4.348-.785,.871-1.821,1.613-3.169,2.266l-.075,.036ZM6.66,10.404c-.041,.505-.164,2.246-.164,5.181,.011,1.572,.546,2.958,1.591,4.118,.74,.822,1.718,1.526,2.989,2.151,1.271-.625,2.249-1.329,2.989-2.151,1.045-1.16,1.58-2.546,1.591-4.119,0-2.934-.122-4.675-.164-5.18H6.66Z" fill="#fff"></path></svg>
                           <svg v-if="selectedLang && selectedLang.code === 'cz'" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"><path d="M1,24c0,2.209,1.791,4,4,4H27c2.209,0,4-1.791,4-4V15H1v9Z" fill="#c62d25"></path><path d="M27,4H5c-2.209,0-4,1.791-4,4v8H31V8c0-2.209-1.791-4-4-4Z" fill="#fff"></path><path d="M2.316,26.947l13.684-10.947L2.316,5.053c-.803,.732-1.316,1.776-1.316,2.947V24c0,1.172,.513,2.216,1.316,2.947Z" fill="#1e427b"></path><path d="M27,4H5c-2.209,0-4,1.791-4,4V24c0,2.209,1.791,4,4,4H27c2.209,0,4-1.791,4-4V8c0-2.209-1.791-4-4-4Zm3,20c0,1.654-1.346,3-3,3H5c-1.654,0-3-1.346-3-3V8c0-1.654,1.346-3,3-3H27c1.654,0,3,1.346,3,3V24Z" opacity=".15"></path><path d="M27,5H5c-1.657,0-3,1.343-3,3v1c0-1.657,1.343-3,3-3H27c1.657,0,3,1.343,3,3v-1c0-1.657-1.343-3-3-3Z" fill="#fff" opacity=".2"></path></svg>
                           <svg v-if="selectedLang && selectedLang.code === 'hu'" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"><path fill="#fff" d="M1 11H31V21H1z"></path><path d="M5,4H27c2.208,0,4,1.792,4,4v4H1v-4c0-2.208,1.792-4,4-4Z" fill="#be373c"></path><path d="M5,20H27c2.208,0,4,1.792,4,4v4H1v-4c0-2.208,1.792-4,4-4Z" transform="rotate(180 16 24)" fill="#4f6f52"></path><path d="M27,4H5c-2.209,0-4,1.791-4,4V24c0,2.209,1.791,4,4,4H27c2.209,0,4-1.791,4-4V8c0-2.209-1.791-4-4-4Zm3,20c0,1.654-1.346,3-3,3H5c-1.654,0-3-1.346-3-3V8c0-1.654,1.346-3,3-3H27c1.654,0,3,1.346,3,3V24Z" opacity=".15"></path><path d="M27,5H5c-1.657,0-3,1.343-3,3v1c0-1.657,1.343-3,3-3H27c1.657,0,3,1.343,3,3v-1c0-1.657-1.343-3-3-3Z" fill="#fff" opacity=".2"></path></svg>
                           <svg v-if="selectedLang && selectedLang.code === 'pl'" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"><path d="M1,24c0,2.209,1.791,4,4,4H27c2.209,0,4-1.791,4-4V15H1v9Z" fill="#cb2e40"></path><path d="M27,4H5c-2.209,0-4,1.791-4,4v8H31V8c0-2.209-1.791-4-4-4Z" fill="#fff"></path><path d="M5,28H27c2.209,0,4-1.791,4-4V8c0-2.209-1.791-4-4-4H5c-2.209,0-4,1.791-4,4V24c0,2.209,1.791,4,4,4ZM2,8c0-1.654,1.346-3,3-3H27c1.654,0,3,1.346,3,3V24c0,1.654-1.346,3-3,3H5c-1.654,0-3-1.346-3-3V8Z" opacity=".15"></path><path d="M27,5H5c-1.657,0-3,1.343-3,3v1c0-1.657,1.343-3,3-3H27c1.657,0,3,1.343,3,3v-1c0-1.657-1.343-3-3-3Z" fill="#fff" opacity=".2"></path></svg>
                        </template>
                        <perfect-scrollbar>
                            <b-dropdown-item
                                v-for="item in countryList"
                                :key="item.code"
                                link-class="d-flex align-items-center"
                                :active="$i18n.locale === item.code"
                                @click.prevent="changeLanguage(item)"
                            >
                               <svg v-if="item.code === 'sk'" xmlns="http://www.w3.org/2000/svg" width="32" height="32" class="flag-width" viewBox="0 0 32 32"><path fill="#204c9e" d="M1 11H31V21H1z"></path><path d="M5,4H27c2.208,0,4,1.792,4,4v4H1v-4c0-2.208,1.792-4,4-4Z" fill="#fff"></path><path d="M5,20H27c2.208,0,4,1.792,4,4v4H1v-4c0-2.208,1.792-4,4-4Z" transform="rotate(180 16 24)" fill="#db362f"></path><path d="M27,4H5c-2.209,0-4,1.791-4,4V24c0,2.209,1.791,4,4,4H27c2.209,0,4-1.791,4-4V8c0-2.209-1.791-4-4-4Zm3,20c0,1.654-1.346,3-3,3H5c-1.654,0-3-1.346-3-3V8c0-1.654,1.346-3,3-3H27c1.654,0,3,1.346,3,3V24Z" opacity=".15"></path><path d="M27,5H5c-1.657,0-3,1.343-3,3v1c0-1.657,1.343-3,3-3H27c1.657,0,3,1.343,3,3v-1c0-1.657-1.343-3-3-3Z" fill="#fff" opacity=".2"></path><path d="M15.65,10.232s.178,1.784,.178,5.353c-.025,3.645-2.751,5.49-4.752,6.46-2.001-.97-4.726-2.815-4.752-6.46,0-3.569,.178-5.353,.178-5.353H15.65Z" fill="#db362f"></path><path d="M10.673,19.945v-4.462c-1.511,0-1.94,.134-2.392,.27,.042-.456,.042-.915,0-1.371,.452,.137,.881,.27,2.392,.27v-1.24c-.477,0-1.135,.019-1.892,.277,.043-.457,.043-.917,0-1.374,.757,.254,1.415,.274,1.892,.274,0-.359-.111-1.132-.251-1.772,.436,.039,.874,.039,1.31,0-.14,.639-.251,1.412-.251,1.772,.477,0,1.135-.019,1.892-.274-.043,.457-.043,.917,0,1.374-.757-.258-1.415-.277-1.892-.277v1.24c1.511,0,1.94-.134,2.392-.27-.042,.456-.042,.915,0,1.371-.452-.137-.881-.27-2.392-.27v4.462h-.808Z" fill="#fff"></path><path d="M15.65,10.232s.178,1.784,.178,5.353c-.025,3.645-2.751,5.49-4.752,6.46-2.001-.97-4.726-2.815-4.752-6.46,0-3.569,.178-5.353,.178-5.353H15.65Z" fill="none"></path><path d="M11.076,22.044c1.241-.602,2.761-1.542,3.742-3.038-.007-.014-.011-.031-.017-.045-.56-1.184-1.576-1.367-2.268-.409-.089-.209-.191-.399-.304-.565-.805-1.181-1.973-.929-2.609,.565-.287-.397-.645-.614-1.014-.614-.518,0-.973,.424-1.268,1.072,.982,1.494,2.499,2.432,3.739,3.034Z" fill="#204c9e"></path><path d="M11.076,22.235l-.075-.036c-1.348-.654-2.385-1.395-3.169-2.266-1.103-1.225-1.668-2.687-1.679-4.347,0-3.537,.177-5.353,.179-5.371l.015-.155H15.806l.015,.155c.002,.018,.179,1.834,.179,5.37-.012,1.661-.577,3.123-1.679,4.348-.785,.871-1.821,1.613-3.169,2.266l-.075,.036ZM6.66,10.404c-.041,.505-.164,2.246-.164,5.181,.011,1.572,.546,2.958,1.591,4.118,.74,.822,1.718,1.526,2.989,2.151,1.271-.625,2.249-1.329,2.989-2.151,1.045-1.16,1.58-2.546,1.591-4.119,0-2.934-.122-4.675-.164-5.18H6.66Z" fill="#fff"></path></svg>
                               <svg v-if="item.code === 'cz'" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"><path d="M1,24c0,2.209,1.791,4,4,4H27c2.209,0,4-1.791,4-4V15H1v9Z" fill="#c62d25"></path><path d="M27,4H5c-2.209,0-4,1.791-4,4v8H31V8c0-2.209-1.791-4-4-4Z" fill="#fff"></path><path d="M2.316,26.947l13.684-10.947L2.316,5.053c-.803,.732-1.316,1.776-1.316,2.947V24c0,1.172,.513,2.216,1.316,2.947Z" fill="#1e427b"></path><path d="M27,4H5c-2.209,0-4,1.791-4,4V24c0,2.209,1.791,4,4,4H27c2.209,0,4-1.791,4-4V8c0-2.209-1.791-4-4-4Zm3,20c0,1.654-1.346,3-3,3H5c-1.654,0-3-1.346-3-3V8c0-1.654,1.346-3,3-3H27c1.654,0,3,1.346,3,3V24Z" opacity=".15"></path><path d="M27,5H5c-1.657,0-3,1.343-3,3v1c0-1.657,1.343-3,3-3H27c1.657,0,3,1.343,3,3v-1c0-1.657-1.343-3-3-3Z" fill="#fff" opacity=".2"></path></svg>
                               <svg v-if="item.code === 'hu'" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"><path fill="#fff" d="M1 11H31V21H1z"></path><path d="M5,4H27c2.208,0,4,1.792,4,4v4H1v-4c0-2.208,1.792-4,4-4Z" fill="#be373c"></path><path d="M5,20H27c2.208,0,4,1.792,4,4v4H1v-4c0-2.208,1.792-4,4-4Z" transform="rotate(180 16 24)" fill="#4f6f52"></path><path d="M27,4H5c-2.209,0-4,1.791-4,4V24c0,2.209,1.791,4,4,4H27c2.209,0,4-1.791,4-4V8c0-2.209-1.791-4-4-4Zm3,20c0,1.654-1.346,3-3,3H5c-1.654,0-3-1.346-3-3V8c0-1.654,1.346-3,3-3H27c1.654,0,3,1.346,3,3V24Z" opacity=".15"></path><path d="M27,5H5c-1.657,0-3,1.343-3,3v1c0-1.657,1.343-3,3-3H27c1.657,0,3,1.343,3,3v-1c0-1.657-1.343-3-3-3Z" fill="#fff" opacity=".2"></path></svg>
                               <svg v-if="item.code === 'pl'" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"><path d="M1,24c0,2.209,1.791,4,4,4H27c2.209,0,4-1.791,4-4V15H1v9Z" fill="#cb2e40"></path><path d="M27,4H5c-2.209,0-4,1.791-4,4v8H31V8c0-2.209-1.791-4-4-4Z" fill="#fff"></path><path d="M5,28H27c2.209,0,4-1.791,4-4V8c0-2.209-1.791-4-4-4H5c-2.209,0-4,1.791-4,4V24c0,2.209,1.791,4,4,4ZM2,8c0-1.654,1.346-3,3-3H27c1.654,0,3,1.346,3,3V24c0,1.654-1.346,3-3,3H5c-1.654,0-3-1.346-3-3V8Z" opacity=".15"></path><path d="M27,5H5c-1.657,0-3,1.343-3,3v1c0-1.657,1.343-3,3-3H27c1.657,0,3,1.343,3,3v-1c0-1.657-1.343-3-3-3Z" fill="#fff" opacity=".2"></path></svg>

                               <span>{{ item.name }}</span>
                            </b-dropdown-item>
                        </perfect-scrollbar>
                    </b-dropdown>

<!--                    <b-dropdown toggle-tag="a" variant="icon-only" toggle-class="nav-link" class="nav-item message-dropdown" :right="true">-->
<!--                        <template #button-content>-->
<!--                            <svg-->
<!--                                xmlns="http://www.w3.org/2000/svg"-->
<!--                                width="24"-->
<!--                                height="24"-->
<!--                                viewBox="0 0 24 24"-->
<!--                                fill="none"-->
<!--                                stroke="currentColor"-->
<!--                                stroke-width="2"-->
<!--                                stroke-linecap="round"-->
<!--                                stroke-linejoin="round"-->
<!--                                class="feather feather-mail"-->
<!--                            >-->
<!--                                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>-->
<!--                                <polyline points="22,6 12,13 2,6"></polyline>-->
<!--                            </svg>-->
<!--                        </template>-->

<!--                        <b-dropdown-item>-->
<!--                            <b-media class="media">-->
<!--                                <template #aside>-->
<!--                                    <div class="avatar avatar-xl">-->
<!--                                        <span class="avatar-title rounded-circle">KY</span>-->
<!--                                    </div>-->
<!--                                </template>-->
<!--                                <h5 class="usr-name">Kara Young</h5>-->
<!--                                <p class="msg-title">ACCOUNT UPDATE</p>-->
<!--                            </b-media>-->
<!--                        </b-dropdown-item>-->
<!--                        <b-dropdown-item>-->
<!--                            <b-media class="media">-->
<!--                                <template #aside>-->
<!--                                    <img src="@/assets/images/profile-15.jpeg" alt="avatar" />-->
<!--                                </template>-->
<!--                                <h5 class="usr-name">Daisy Anderson</h5>-->
<!--                                <p class="msg-title">ACCOUNT UPDATE</p>-->
<!--                            </b-media>-->
<!--                        </b-dropdown-item>-->
<!--                        <b-dropdown-item>-->
<!--                            <b-media class="media">-->
<!--                                <template #aside>-->
<!--                                    <div class="avatar avatar-xl">-->
<!--                                        <span class="avatar-title rounded-circle">OG</span>-->
<!--                                    </div>-->
<!--                                </template>-->
<!--                                <h5 class="usr-name">Oscar Garner</h5>-->
<!--                                <p class="msg-title">ACCOUNT UPDATE</p>-->
<!--                            </b-media>-->
<!--                        </b-dropdown-item>-->
<!--                    </b-dropdown>-->

<!--                    <div class="dropdown b-dropdown nav-item message-dropdown btn-group">-->
<!--                        <a @click.prevent="toogleFullscreen" href="#" class="nav-link">-->
<!--                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-minimize" data-v-5522efca=""><path d="M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 1 2-2h3M3 16h3a2 2 0 0 1 2 2v3"></path></svg>-->
<!--                        </a>-->
<!--                    </div>-->

<!--                    <b-dropdown  toggle-tag="a" variant="icon-only" toggle-class="nav-link" menu-class="notification-scroll" class="nav-item notification-dropdown" :right="true">-->
<!--                        <template #button-content>-->
<!--                            <svg-->
<!--                                xmlns="http://www.w3.org/2000/svg"-->
<!--                                width="24"-->
<!--                                height="24"-->
<!--                                viewBox="0 0 24 24"-->
<!--                                fill="none"-->
<!--                                stroke="currentColor"-->
<!--                                stroke-width="2"-->
<!--                                stroke-linecap="round"-->
<!--                                stroke-linejoin="round"-->
<!--                                class="feather feather-bell"-->
<!--                            >-->
<!--                                <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>-->
<!--                                <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>-->
<!--                            </svg>-->
<!--                            <span class="badge badge-success"></span>-->
<!--                        </template>-->

<!--                        <b-dropdown-item>-->
<!--                            <b-media class="server-log">-->
<!--                                <template #aside>-->
<!--                                    <svg-->
<!--                                        xmlns="http://www.w3.org/2000/svg"-->
<!--                                        width="24"-->
<!--                                        height="24"-->
<!--                                        viewBox="0 0 24 24"-->
<!--                                        fill="none"-->
<!--                                        stroke="currentColor"-->
<!--                                        stroke-width="2"-->
<!--                                        stroke-linecap="round"-->
<!--                                        stroke-linejoin="round"-->
<!--                                        class="feather feather-server"-->
<!--                                    >-->
<!--                                        <rect x="2" y="2" width="20" height="8" rx="2" ry="2"></rect>-->
<!--                                        <rect x="2" y="14" width="20" height="8" rx="2" ry="2"></rect>-->
<!--                                        <line x1="6" y1="6" x2="6" y2="6"></line>-->
<!--                                        <line x1="6" y1="18" x2="6" y2="18"></line>-->
<!--                                    </svg>-->
<!--                                </template>-->
<!--                                <div class="data-info">-->
<!--                                    <h6 class="">Server Rebooted</h6>-->
<!--                                    <p class="">45 min ago</p>-->
<!--                                </div>-->

<!--                                <div class="icon-status">-->
<!--                                    <svg-->
<!--                                        xmlns="http://www.w3.org/2000/svg"-->
<!--                                        width="24"-->
<!--                                        height="24"-->
<!--                                        viewBox="0 0 24 24"-->
<!--                                        fill="none"-->
<!--                                        stroke="currentColor"-->
<!--                                        stroke-width="2"-->
<!--                                        stroke-linecap="round"-->
<!--                                        stroke-linejoin="round"-->
<!--                                        class="feather feather-x"-->
<!--                                    >-->
<!--                                        <line x1="18" y1="6" x2="6" y2="18"></line>-->
<!--                                        <line x1="6" y1="6" x2="18" y2="18"></line>-->
<!--                                    </svg>-->
<!--                                </div>-->
<!--                            </b-media>-->
<!--                        </b-dropdown-item>-->
<!--                        <b-dropdown-divider></b-dropdown-divider>-->
<!--                        <b-dropdown-item>-->
<!--                            <b-media>-->
<!--                                <template #aside>-->
<!--                                    <svg-->
<!--                                        xmlns="http://www.w3.org/2000/svg"-->
<!--                                        width="24"-->
<!--                                        height="24"-->
<!--                                        viewBox="0 0 24 24"-->
<!--                                        fill="none"-->
<!--                                        stroke="currentColor"-->
<!--                                        stroke-width="2"-->
<!--                                        stroke-linecap="round"-->
<!--                                        stroke-linejoin="round"-->
<!--                                        class="feather feather-heart"-->
<!--                                    >-->
<!--                                        <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>-->
<!--                                    </svg>-->
<!--                                </template>-->
<!--                                <div class="data-info">-->
<!--                                    <h6 class="">Licence Expiring Soon</h6>-->
<!--                                    <p class="">8 hrs ago</p>-->
<!--                                </div>-->

<!--                                <div class="icon-status">-->
<!--                                    <svg-->
<!--                                        xmlns="http://www.w3.org/2000/svg"-->
<!--                                        width="24"-->
<!--                                        height="24"-->
<!--                                        viewBox="0 0 24 24"-->
<!--                                        fill="none"-->
<!--                                        stroke="currentColor"-->
<!--                                        stroke-width="2"-->
<!--                                        stroke-linecap="round"-->
<!--                                        stroke-linejoin="round"-->
<!--                                        class="feather feather-x"-->
<!--                                    >-->
<!--                                        <line x1="18" y1="6" x2="6" y2="18"></line>-->
<!--                                        <line x1="6" y1="6" x2="18" y2="18"></line>-->
<!--                                    </svg>-->
<!--                                </div>-->
<!--                            </b-media>-->
<!--                        </b-dropdown-item>-->
<!--                        <b-dropdown-divider></b-dropdown-divider>-->
<!--                        <b-dropdown-item>-->
<!--                            <b-media class="file-upload">-->
<!--                                <template #aside>-->
<!--                                    <svg-->
<!--                                        xmlns="http://www.w3.org/2000/svg"-->
<!--                                        width="24"-->
<!--                                        height="24"-->
<!--                                        viewBox="0 0 24 24"-->
<!--                                        fill="none"-->
<!--                                        stroke="currentColor"-->
<!--                                        stroke-width="2"-->
<!--                                        stroke-linecap="round"-->
<!--                                        stroke-linejoin="round"-->
<!--                                        class="feather feather-file-text"-->
<!--                                    >-->
<!--                                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>-->
<!--                                        <polyline points="14 2 14 8 20 8"></polyline>-->
<!--                                        <line x1="16" y1="13" x2="8" y2="13"></line>-->
<!--                                        <line x1="16" y1="17" x2="8" y2="17"></line>-->
<!--                                        <polyline points="10 9 9 9 8 9"></polyline>-->
<!--                                    </svg>-->
<!--                                </template>-->
<!--                                <div class="data-info">-->
<!--                                    <h6 class="">Kelly Portfolio.pdf</h6>-->
<!--                                    <p class="">670 kb</p>-->
<!--                                </div>-->

<!--                                <div class="icon-status">-->
<!--                                    <svg-->
<!--                                        xmlns="http://www.w3.org/2000/svg"-->
<!--                                        width="24"-->
<!--                                        height="24"-->
<!--                                        viewBox="0 0 24 24"-->
<!--                                        fill="none"-->
<!--                                        stroke="currentColor"-->
<!--                                        stroke-width="2"-->
<!--                                        stroke-linecap="round"-->
<!--                                        stroke-linejoin="round"-->
<!--                                        class="feather feather-check"-->
<!--                                    >-->
<!--                                        <polyline points="20 6 9 17 4 12"></polyline>-->
<!--                                    </svg>-->
<!--                                </div>-->
<!--                            </b-media>-->
<!--                        </b-dropdown-item>-->
<!--                    </b-dropdown>-->
<!--                    <h6 class="nav-item" v-if="user">{{ user.name }}</h6>-->
                    <b-dropdown toggle-tag="a" variant="icon-only" toggle-class="user nav-link" class="nav-item user-profile-dropdown" :right="true" v-if="user">
                        <template #button-content>
                                <img v-if="user.pouzivatel.images" :src="user.pouzivatel.images.original_url" alt="avatar" />
                                <svg v-if="!user.pouzivatel.images" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-user placeholder" data-v-5522efca=""><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
                        </template>

<!--                        <b-dropdown-item to="/users/profile">-->
<!--                            <svg-->
<!--                                xmlns="http://www.w3.org/2000/svg"-->
<!--                                width="24"-->
<!--                                height="24"-->
<!--                                viewBox="0 0 24 24"-->
<!--                                fill="none"-->
<!--                                stroke="currentColor"-->
<!--                                stroke-width="2"-->
<!--                                stroke-linecap="round"-->
<!--                                stroke-linejoin="round"-->
<!--                                class="feather feather-user"-->
<!--                            >-->
<!--                                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>-->
<!--                                <circle cx="12" cy="7" r="4"></circle>-->
<!--                            </svg>-->
<!--                            Profile-->
<!--                        </b-dropdown-item>-->
                        <b-dropdown-divider></b-dropdown-divider>
                        <b-dropdown-item>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-user placeholder" data-v-5522efca=""><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
                            {{ user.pouzivatel.name }}
                        </b-dropdown-item>
                        <b-dropdown-divider></b-dropdown-divider>
                        <b-dropdown-item @click="logout">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-log-out"
                            >
                                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                                <polyline points="16 17 21 12 16 7"></polyline>
                                <line x1="21" y1="12" x2="9" y2="12"></line>
                            </svg>
                            {{ $t('log_out') }}
                        </b-dropdown-item>
                    </b-dropdown>

                    <div class="dropdown b-dropdown nav-item hamburger btn-group">
                        <a href="javascript:void(0);" class="sidebarCollapse" data-placement="bottom" @click="$store.commit('toggleSideBar', !$store.state.is_show_sidebar)">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-menu"
                            >
                                <line x1="3" y1="12" x2="21" y2="12"></line>
                                <line x1="3" y1="6" x2="21" y2="6"></line>
                                <line x1="3" y1="18" x2="21" y2="18"></line>
                            </svg>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <!--  END NAVBAR  -->
        <!--  BEGIN NAVBAR  -->
<!--        <div class="sub-header-container">-->
<!--            <header class="header navbar navbar-expand-sm">-->
<!--                <a href="javascript:void(0);" class="sidebarCollapse" data-placement="bottom" @click="$store.commit('toggleSideBar', !$store.state.is_show_sidebar)">-->
<!--                    <svg-->
<!--                        xmlns="http://www.w3.org/2000/svg"-->
<!--                        width="24"-->
<!--                        height="24"-->
<!--                        viewBox="0 0 24 24"-->
<!--                        fill="none"-->
<!--                        stroke="currentColor"-->
<!--                        stroke-width="2"-->
<!--                        stroke-linecap="round"-->
<!--                        stroke-linejoin="round"-->
<!--                        class="feather feather-menu"-->
<!--                    >-->
<!--                        <line x1="3" y1="12" x2="21" y2="12"></line>-->
<!--                        <line x1="3" y1="6" x2="21" y2="6"></line>-->
<!--                        <line x1="3" y1="18" x2="21" y2="18"></line>-->
<!--                    </svg>-->
<!--                </a>-->

<!--                &lt;!&ndash; Portal vue for Breadcrumb &ndash;&gt;-->
<!--                <portal-target name="breadcrumb"></portal-target>-->


<!--            </header>-->
<!--        </div>-->
        <!--  END NAVBAR  -->

    </header>
</template>
<script>
    import { mapGetters, mapActions } from "vuex";

    export default {
        data() {
            return {
                selectedLang: null,
                countryList: this.$store.state.countryList,
            };
        },
        computed: {
          ...mapGetters("auth", ["user"])
        },
        watch: {
            '$i18n.locale'(newLocale) {
                const lang = this.countryList.find(item => item.code === newLocale);
                if (lang) {
                    this.selectedLang = lang;
                }
            }
        },
        mounted() {
            this.selectedLang = this.$appSetting.toggleLanguage();

            this.toggleMode();

        },
        methods: {
          ...mapActions("auth", ["sendLogoutRequest"]),

            toggleMode(mode) {
                this.$appSetting.toggleMode(mode);
            },

            async changeLanguage(item) {
                // Použiť action updateLanguage, ktorá automaticky zavolá API ak je používateľ prihlásený
                await this.$store.dispatch('updateLanguage', item.code);
                this.selectedLang = item;
                // Refresh stránky po zmene jazyka
                window.location.reload();
            },

            logout() {
              this.sendLogoutRequest()
            },
            toogleFullscreen() {
                if (!document.fullscreenElement) {
                    document.documentElement.requestFullscreen();
                } else {
                    if (document.exitFullscreen) {
                        document.exitFullscreen();
                    }
                }
            }
        }
    };
</script>
